import React from 'react';
import styles from './AccreditationDropdownFilter.module.scss';
import { Select } from 'antd';
const { Option } = Select;

export default function AccreditationDropdownFilter(props: {
  handleSelectCategory: (id: string) => void;
  list: {
    value: string,
    title: string,
  }[];
  defaultValue: string[] | string | undefined;
}) {
  function handleChange(value: string) {
    props.handleSelectCategory(value);
  }
  return (
    <div className={styles.container}>
      <Select defaultValue={props.defaultValue || 'ALL'} className={styles.select} onChange={handleChange} size="large">
        {props.list.map((item) => (
          <Option key={item.value} value={item.value}>
            {item.title}
          </Option>
        ))}
      </Select>
    </div>
  );
}
